import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash"
export default class extends Controller {
  connect() {
    // Auto-dismiss after 3 seconds
    setTimeout(() => {
      this.close();
    }, 3000);
  }

  close() {
    // Fade out animation before removing
    this.element.style.animation = 'slideOutRight 0.3s ease-in';
    setTimeout(() => {
      this.element.remove();
    }, 300);
  }
}
